/* eslint-disable prefer-rest-params */
define([
    'jQuery',
    'toolkit/b-layer/b-layer',
    'mrg-form/b-form/b-form',
    'toolkit/b-input/b-input',
], ($, BLayer) => {
    return BLayer.extend('add-dialog', {
        inner: true,
        renderMode: 'replace',
        canHide: true,

        init() {
            this.templateBlock = 'b-layer';

            BLayer.fn.init.apply(this, arguments);
        },

        onRender() {
            this._inputEl = this.$('.js-models');
            this._form = this.$('form').getBlock();
            this._inputEl.focus();
        },

        onOk() {
            this.emit('approve', this._inputEl.val());
        },

        onHide() {
            this.emit('cancel');
        },

        setErrors(errors) {
            this._form.showErrors({
                Model: 'default',
            });

            this._form.$('.js-default.js-error').html(errors);
        },

        hideErrors() {},

        getData() {
            let data = BLayer.fn.getData.apply(this, arguments);

            data = $.extend(
                {},
                {
                    canHide: true,
                    mods: ['add-dialog'],
                    block: 'b-panel',
                    params: {
                        mods: ['popup', 'service'],

                        header: {
                            title: data.title || 'Добавить',
                        },
                        desc: data.desc,
                        close: true,
                        view: 'b-form',
                        content: {
                            mods: ['responsive', 'compact', 'popup'],
                            nativesubmit: false,
                            fields: [
                                {
                                    block: 'b-input',
                                    mods: ['responsive', 'compact'],
                                    cssClass: 'js-models',
                                    label: data.labelText,
                                    errors: Object.keys(data.errors).map(
                                        (error) => {
                                            return {
                                                type: error,
                                                text: data.errors[error],
                                            };
                                        },
                                    ),
                                    message: data.message,
                                    props: {
                                        type: 'text',
                                        name: 'Model',
                                        required: 'true',
                                        autofocus: 'autofocus',
                                        tabindex: 1,
                                        placeholder: data.placeholder,
                                    },
                                },
                            ],

                            controls: {
                                mods: ['popup'],
                                items: [
                                    {
                                        mods: ['main'],
                                        name: 'ok',
                                        type: 'submit',
                                        text: data.approveText || 'Подтвердить',
                                    },
                                    {
                                        name: 'close',
                                        text: data.cancelText || 'Отменить',
                                    },
                                ],
                            },
                        },
                    },
                },
            );

            return data;
        },

        destroy() {
            if (this._suggest) {
                this._suggest.destroy();
            }

            // BLayer.fn.destroy → BControlsGroup.fn.destroy → BToolkitCore.fn.destroy → BToolkitCore.fn._destroyInner → BForm.fn.destroy
            // this._form.destroy();
            BLayer.fn.destroy.apply(this, arguments);
        },
    });
});
